<template>
  <div class="set">
    <van-nav-bar
      title="账户设置"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <!-- <div
      class="name"
      @click="gomeans"
    >
      <div class="tu">
        <img
          src="../../assets/user.png"
          alt=""
        >
      </div>
      <div class="centen">
        <div class="top">{{name}}</div>
        <div class="bottom">{{mobile}}</div>
      </div>
      <div class="jian">
      </div>
    </div> -->
    <div
      class="name list"
    >
      <div class="centen">
        账 号 ID： {{mobile}}
      </div>
      <!-- <div class="jian">
        <van-icon name="arrow" />
      </div> -->
    </div>
     <div
      class="name list"
    >
      <div class="centen">
        用 户 名： {{name}}
      </div>
      <!-- <div class="jian">
        <van-icon name="arrow" />
      </div> -->
    </div>
     <div
      class="name list"
    >
      <div class="centen">
        电子邮箱： {{you}}
      </div>
      <!-- <div class="jian">
        <van-icon name="arrow" />
      </div> -->
    </div>
     <div
      class="name list"
    >
      <div class="centen">
        注册时间： 
      {{time}}

      </div>
      <!-- <div class="jian">
        <van-icon name="arrow" />
      </div> -->
    </div>
    <div
      class="name list"
     
    >
      <div class="centen">
        认证状态：{{certification==1?'已认证':'未认证'}}
      </div>
      <div v-show="certification!=1" class=" renz"  @click="fa">
         <van-button
      type="danger"
      size="small"
      style="font-size:0.45rem;"
     
    >认证账号</van-button>
      </div>
    </div>
    <div
      class="name list"
      @click="fax"
      v-show="certification==1"
    >
      <div class="centen">
        认证信息
      </div>
      <div class="jian">
        <van-icon name="arrow" />
      </div>
    </div>
     <div
      class="name list"
     
    >
      <div class="centen">
        是否开启推荐信息：
      </div>
      <div  class=" renz" >
           <van-switch @change="gos" v-model="checked" />

      </div>
    </div>
    <div
      class="name list"
      @click="gorevise"
    >
      <div class="centen">
        修改密码
      </div>
      <div class="jian">
        <van-icon name="arrow" />
      </div>
    </div>
    <!-- <div
      class="name list"
      @click="gorevise1"
    >
      <div class="centen">
        修改支付密码
      </div>
      <div class="jian">
        <van-icon name="arrow" />
      </div>
    </div> -->
     <div
      class="name list"
      @click="gooff"
    >
      <div class="centen">
       账号注销
      </div>
      <div class="jian">
        <van-icon name="arrow" />
      </div>
    </div>
    <van-button
      class="but"
      type="danger"
      size="large"
      style="font-size:0.45rem;"
      @click="out"
    >退出登录</van-button>
      <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div class="mi">
        <p>请输入密码浏览</p>
        <input
          type="text"
          v-model="value"
        >
      </div>

      <div class="">
        <van-button
          type="primary"
          size="large"
          @click="ok"
        >确认</van-button>
      </div>

    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue';
import { NavBar, Toast, Button, Icon,Popup,Switch } from 'vant';
// import 'vant/lib/button/style/less';
Vue.use(NavBar).use(Toast).use(Button).use(Icon).use(Popup).use(Switch)
export default {
  created () {
    this.name = JSON.parse(localStorage.getItem('user-name')).id
    this.mobile = JSON.parse(localStorage.getItem('user-mobile')).id
     this.axios.post('yanzheng', { }).then(res => {
        console.log(res)
        this.certification=res.data.data.certification
      }).catch(ref => { })
    this.axios.post('userInfo', { store_id: this.$store.state.shopid, }).then(res => {
        if (res.data.code == 200) {
          console.log(res)
          // this.certification=res.data.info.certification
          this.you=res.data.info.user_email
           let data = new Date(res.data.info.create_time
 * 1000)
          let year = data.getFullYear()
          // console.log(1)
          let month = data.getMonth() + 1
          let day = data.getDate()
          month = month < 10 ? '0' + month : month
          day = day < 10 ? "0" + day : day
          console.log()
          this.time = year + "-" + month + "-" + day
        }
      }).catch(ref => { })
  },
  data () {
    return {
      name: '',
      mobile: "",
      show:false,
      value:'',
      ren:0,
      certification:0,
      you:'',
      time:'',
      checked:false
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    gomeans () {
      // this.$router.push('means')
    },
    goaddres () {
      this.$router.push('address')
    },
    gos(){
      //  Toast('10')

       this.axios.post('recomInfo', {  recom:this.checked?1:2, }).then(res => {
        // console.log(res)
       Toast(res.data.info)
   
        
      }).catch(ref => { })
    },
    gorevise () {
            this.$router.push({name:'revise',query:{id:0}})

      // this.show=true
      // this.$router.push('ren')
    },
     gorevise1 () {
      this.$router.push({name:'revise',query:{id:1}})
      // this.show=true
      // this.$router.push('ren')
    },
    fa () {
       this.$router.push({
          name: 'ren',
         
        })
      // this.$router.push('tax')
    },
     fax () {
       this.$router.push({
          name: 'renx',
         
        })
      // this.$router.push('tax')
    },
     ok () {
      
       
    },
    gooff(){
//       if(JSON.parse(localStorage.getItem('user')).id==7360){
//         this.$router.push('opvip')   
// return
//       }
        this.$router.push('logoff')   
    },
    out () {
      localStorage.setItem('user-level', JSON.stringify({ id: 0 }))
      localStorage.setItem('user-name', JSON.stringify({ id: '' }))
      localStorage.setItem('vip', JSON.stringify({ id: 0 }))
      localStorage.setItem('user', JSON.stringify({ id: 0 }))
      localStorage.setItem('user-mobile', JSON.stringify({ id: "" }))
      localStorage.setItem('token', JSON.stringify({ id: "" }))
      this.$router.push('login')
    }
  },
}
</script>  
<style>
.van-switch__node{
  width:0.75rem;
  height: 0.75rem;
}
.van-switch--on .van-switch__node{
      transform: translateX(0.8rem);
}
</style>
<style lang="less" scoped>

.set {
  height: 100%;
  background-color: #f5f5f5;
}
.name {
  display: flex;
  height: 2.08rem;
  background-color: #fff;
  padding: 0.2rem;
  border-bottom: 1px solid #eee;
  .tu {
    flex: 0.3;
    img {
      width: 1.52rem;
    }
  }
  .centen {
    flex: 1;
    padding-top: 0.2rem;
    .top {
      font-size: 0.4rem;
      color: #333;
    }
    .bottom {
      padding-top: 0.2rem;
      font-size: 0.26rem;
      color: #999;
    }
  }
  .jian {
    flex: 0.13;
    padding-top: 0.6rem;
    font-size: 0.5rem;
    color: #e3e3e3;
  }
  .renz{
    flex: 0.33;
    padding-top: 0;
  }
}
.mi {
  padding: 0.5rem;
  text-align: center;

  p {
    font-size: 0.5rem;
    margin: 0.5rem;
  }
  input {
    height: 1rem;
    width: 70%;
    border-radius: 5%;
    font-size: 0.4rem;
  }
  margin-bottom: 1rem;
}
.list {
  padding-left: 0.5rem;
  height: 1.3rem;
  .centen {
    font-size: 0.38rem;
  }
  .jian {
    flex: 0.1;
    padding-top: 0.2rem;
  }
}
.but {
  position: fixed;
  bottom: 0;
}
</style>